import { Controller } from "react-hook-form";
import {
  DropdownItem,
  ProfilePaymentIcon,
  ProfilePaymentIcons,
} from "@components";
import { cn } from "@utils";
import EditorDropdown from "./EditorDropdown";

export default function PaymentProfilesDropdown({
  control,
  watch,
  paymentProfiles = [],
  variant = "inline",
  edited = false,
  disabled = false,
}) {
  const selectedId = watch("paymentProfileId");
  const selected = paymentProfiles.find((p) => p.id === selectedId);
  const label = selected ? (
    <span className="inline-flex items-center gap-1.5">
      {selected.name}
      <ProfilePaymentIcons profile={selected} size="sm" />
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5">
      Default Payment Profile
      <ProfilePaymentIcon paymentType="Default" size="sm" />
    </span>
  );

  return (
    <EditorDropdown
      label={label}
      variant={variant}
      edited={edited}
      disabled={disabled}
      bodyClassName="min-w-56 w-max whitespace-nowrap"
    >
      <div className="px-4 py-2 text-xs font-semibold text-zinc-500 uppercase tracking-wide">
        Payment profile
      </div>
      <Controller
        name="paymentProfileId"
        control={control}
        render={({ field: { value, onChange } }) => (
          <>
            <DropdownItem onClick={() => onChange(null)}>
              <span
                className={cn(
                  "flex items-center gap-2 select-none font-medium",
                  value == null ? "text-primary-500" : "text-zinc-900",
                )}
              >
                <span>Default Payment Profile</span>
                <ProfilePaymentIcon paymentType="Default" size="sm" />
                <span className="text-xs text-zinc-600">
                  {"(each account uses it’s own profile)"}
                </span>
              </span>
            </DropdownItem>
            {paymentProfiles.map((profile) => (
              <DropdownItem
                key={profile.id}
                onClick={() => onChange(profile.id)}
              >
                <span
                  className={cn(
                    "flex items-center gap-2 select-none font-medium",
                    profile.id === value ? "text-primary-500" : "text-zinc-900",
                  )}
                >
                  <span>{profile.name}</span>
                  <ProfilePaymentIcons profile={profile} size="sm" />
                </span>
              </DropdownItem>
            ))}
          </>
        )}
      />
    </EditorDropdown>
  );
}
